// This is a generated file, do not edit.

export const SharedScripts = [
  "about",
  "actorplugin",
  "commune",
  "conditionplugin",
  "dashplugin",
  "datetitleplugin",
  "defocusplugin",
  "dispdateplugin",
  "endlist",
  "erasemacro",
  "falldownplugin",
  "filterplugin",
  "first",
  "flowtrackerplugin",
  "flushplugin",
  "hazeplugin",
  "hearttoneplugin",
  "loadplugins",
  "macro",
  "movecursorplugin",
  "newstaffroll",
  "noiseplugin",
  "param",
  "petal",
  "playsaber",
  "playtimeplugin",
  "plugin_sample",
  "prickeffectplugin",
  "quizsystem",
  "rain",
  "scenes",
  "scenesaveplugin",
  "scripttestplugin",
  "scrollplugin",
  "slideopenplugin",
  "snow",
  "snowplugin",
  "sparkplugin",
  "staffroll",
  "staffrollplugin",
  "suflags_hack",
  "textonoffplugin",
  "titlemenu",
  "tvoffplugin",
  "zoomlensplugin",
  "ゲームメニュー",
  "サブルーチン",
  "ショートカットキー",
  "タイトル",
  "ダイジェスト",
  "テスト",
  "プロローグ",
  "マクロ",
  "ミニ劇場その1",
  "ミニ劇場その2",
  "ミニ劇場その3",
  "ロゴ",
  "変数初期化",
]

export const HScripts = [
  "セイバールート十一日目-118",
  "セイバールート十四日目-101",
  "セイバールート十四日目-111",
  "凛ルート十四日目-108",
  "凛ルート十四日目-130",
  "桜ルート九日目-130",
  "桜ルート五日目-117",
  "桜ルート十一日目-115",
  "桜ルート十二日目-113",
  "桜ルート十四日目-110",
]

export const EngImages = [
  "17死の呪詛(呪)",
  "17死の呪詛・全画面(呪)",
  "17死の呪詛・全画面b(呪)",
  "17死の呪詛・全画面c(呪)",
  "17死の呪詛・全画面d(呪)",
  "17死の呪詛・全画面d",
  "24時間軸説明・サーヴァント",
  "24時間軸説明・サーヴァントb",
  "24時間軸説明・サーヴァントc",
  "25時間軸説明・セイバー",
  "25時間軸説明・セイバーb",
  "25時間軸説明・セイバーc",
  "41呪詛",
  "conf_chgvoice",
  "conf_mousea",
  "conf_mouseb",
  "conf_test",
  "conf_ウィンドウ",
  "conf_変更",
  "c_cs03",
  "c_cs03c",
  "dt_日",
  "dt_月",
  "fate_true_end_button",
  "fnt_bg",
  "hf_normal_end_button",
  "hf_true_end_button",
  "letext001",
  "linebreak",
  "linebreak_a",
  "load_コメント枠",
  "pagebreak",
  "pagebreak_a",
  "rinn03_150",
  "sakura03_150",
  "save_コメント枠",
  "ss_アサシン能力背景",
  "ss_アヴァロンボタン",
  "ss_アーチャー能力背景",
  "ss_エクスカリバーボタン",
  "ss_エヌマ・エリシュボタン",
  "ss_キャスター能力背景",
  "ss_グングニールボタン",
  "ss_ゲイボルクボタン",
  "ss_セイバー能力背景",
  "ss_ダークカリバーボタン",
  "ss_バーサーカー能力背景",
  "ss_ライダー能力背景",
  "ss_ランサー能力背景",
  "ss_十二の試練(裏)ボタン",
  "ss_十二の試練ボタン",
  "ss_干将・莫耶ボタン",
  "ss_暗黒神殿ボタン",
  "ss_無限の剣製ボタン",
  "ss_王の財宝ボタン",
  "ss_風王結界ボタン",
  "ss_騎英の手綱ボタン",
  "ss_鮮血神殿ボタン",
  "stagestart03",
  "tc_caution",
  "tigertitle_sakura_b",
  "tigertitle_sakura_c",
  "イリヤ道場a",
  "イリヤ道場b",
  "キャスター04b(中)",
  "ジャプニカ暗殺帳",
  "ステータス画面",
  "タイガー判子",
  "タイガー注意書き",
  "ライダー03a(中)",
  "凛メモ",
  "凛ルートヒント",
  "桜ルートヒント",
  "藤03a(中)",
]

export const MatureImages = [
  "a10a31b",
  "a23e",
  "a28",
  "a31",
  "a31b",
  "a31c",
  "a32",
  "a33",
  "a33b",
  "a33c",
  "b10",
  "b10b",
  "c12b",
  "c14",
  "c14b",
  "c14c",
  "c21",
  "c24",
]

export const HImages = [
  "27淫虫(一匹)",
  "28淫虫(沢山)",
  "a10a31b",
  "a23e",
  "a28",
  "a29",
  "a29b",
  "a29c",
  "a29d",
  "a31",
  "a31b",
  "a31c",
  "a32",
  "a33",
  "a33b",
  "a33c",
  "ah01",
  "ah01a",
  "ah01b",
  "ah02a",
  "ah02b",
  "ah02b2",
  "ah03",
  "ah04",
  "ah04a",
  "ah04b",
  "ah05",
  "ah05b",
  "ah05d",
  "ah05u",
  "ah06a",
  "ah06a2",
  "ah06b",
  "ah06c",
  "ah07a",
  "ah07b",
  "ah07c",
  "ah07d",
  "ah07d2",
  "ah08",
  "ah09",
  "ah10",
  "ah10b",
  "b10",
  "b10b",
  "bh01",
  "bh01b",
  "bh01c",
  "bh01w200a",
  "bh01w200b",
  "bh02",
  "bh02b",
  "bh02c",
  "bh02d",
  "bh03",
  "bh03b",
  "bh04",
  "bh04b",
  "bh04c",
  "bh04c2",
  "bh04c3",
  "bh04d",
  "bh04d2",
  "bh04d3",
  "bh04d4",
  "bh04d5",
  "bh04e",
  "bh04f",
  "bh04g",
  "bh05",
  "bh05b",
  "bh06",
  "bh06b",
  "bh07",
  "bh08",
  "bh08a",
  "bh08b",
  "bh08c",
  "bh09",
  "bh09b",
  "bh09c",
  "bh09d",
  "c12b",
  "c14",
  "c14b",
  "c14c",
  "c21",
  "c24",
  "c27",
  "c27b",
  "ch01",
  "ch01vt",
  "ch02",
  "ch02b",
  "ch02c",
  "ch02d",
  "ch02e",
  "ch03",
  "ch03a",
  "ch03b",
  "ch03c",
  "ch03d",
  "ch04",
  "ch04h300",
  "ch05",
  "ch05b",
  "ch06",
  "ch07",
  "ch07a2",
  "ch07b",
  "ch08",
  "ch09",
  "i衛宮邸客間(ランプ)-(薄明)",
  "シネスコw400",
  "セイバー特殊03a(中)",
  "セイバー特殊05a(中)",
  "セイバー私服01d(近)",
  "セイバー私服02a頬(近)",
  "セイバー私服12f(近)",
  "セイバー私服20b(近)",
  "セイバー私服20c頬(近)",
  "凛特殊02c(近)",
  "凛特殊02d(近)",
  "凛私服01a(近)",
  "凛私服01c(近)",
  "凛私服04b(近)",
  "凛私服05e頬(中)",
  "凛私服06b頬(中)",
  "凛私服06d(近)",
  "凛私服10a頬2(遠)",
  "凛私服11a頬(中)",
  "凛私服18a(中)",
  "凛私服18a(遠)",
  "凛私服18a頬(中)",
  "凛私服18a頬(遠)",
  "凛私服18b(中)",
  "凛私服18b頬(中)",
  "凛私服18b頬(近)",
  "凛私服18b頬(遠)",
  "桜私服06a頬(遠)",
  "桜私服07b(遠)",
  "桜私服08a2頬(遠)",
  "桜私服09a頬(近)",
  "桜私服10d頬(近)",
  "桜私服13a頬(遠)",
  "桜私服13b頬(遠)",
  "温泉a_a",
  "温泉a_b",
  "温泉a_c",
  "温泉b_a",
  "温泉b_b",
  "温泉b_c",
  "温泉c_a",
  "温泉c_b",
  "温泉c_c",
  "温泉d_a",
]

export const HImagesBishopcruz = [
  "ah02a",
  "ah02b",
  "ah02b2",
  "ah04",
  "ah06a",
  "ah06a2",
  "ah06b",
  "ah06c",
  "ah07a",
  "ah07b",
  "ah07c",
  "ah07d",
  "ah08",
  "bh03",
  "bh03b",
  "bh05",
  "bh05b",
  "bh06",
  "bh08",
  "bh09",
  "bh09b",
  "ch01",
  "ch01vt",
  "ch02",
  "ch02b",
  "ch02d",
  "ch03",
  "ch03b",
  "ch03c",
  "ch03d",
  "ch04",
  "ch04h300",
  "ch06",
  "ch07",
  "ch07a2",
  "ch07b",
  "ch08",
  "ch09",
]

export const HImagesBellandy = [
  "ah02a",
  "ah02b",
  "ah02b2",
  "ah04",
  "ah06a",
  "ah06a2",
  "ah06b",
  "ah06c",
  "ah07a",
  "ah07b",
  "ah07c",
  "ah07d",
  "ah08",
  "bh03",
  "bh03b",
  "bh05",
  "bh05b",
  "bh06",
  "bh08",
  "bh09",
  "bh09b",
  "C27b",
  "ch01",
  "ch01vt",
  "ch02",
  "ch02b",
  "ch02d",
  "ch03",
  "ch03b",
  "ch03c",
  "ch03d",
  "ch04",
  "ch04h300",
  "ch06",
  "ch07",
  "ch07a2",
  "ch07b",
  "ch08",
  "ch09",
]

export const HImagesOriginal = [
  "ah06c",
  "ah07d",
  "bh05",
  "bh05b",
  "bh09",
  "bh09b",
]

export const HImagesDefaultArtist = {
  ah02a: 2,
  ah02b: 2,
  ah04: 1,
  ah06a: 1,
  ah06b: 1,
  ah06c: 3,
  ah07: 2,
  ah07d: 3,
  ah08: 2,
  bh03: 2,
  bh05: 1,
  bh06: 1,
  bh08: 1,
  bh09: 3,
  ch01: 1,
  ch02: 1,
  ch03: 1,
  ch07: 1,
  ch09: 2,
  ch06: 1,
  ch04: 2,
  ch08: 2,
  c27b: 2,
}

export const BGM = {
  "41": "o",
  "bgm_wakame": "o",
  "bgm01": "ov",
  "bgm03": "ov",
  "bgm04": "ov",
  "bgm05": "ov",
  "bgm06": "ov",
  "bgm07": "ov",
  "bgm08": "ov",
  "bgm09": "ov",
  "bgm10": "ov",
  "bgm11": "ov",
  "bgm12": "ov",
  "bgm13": "ov",
  "bgm14": "ov",
  "bgm15": "ov",
  "bgm16": "ov",
  "bgm17": "ov",
  "bgm18": "ov",
  "bgm19": "ov",
  "bgm20": "ov",
  "bgm21": "ov",
  "bgm22": "o",
  "bgm23": "ov",
  "bgm24": "ov",
  "bgm25": "ov",
  "bgm26": "o",
  "bgm27": "o",
  "bgm28": "ov",
  "bgm29": "ov",
  "bgm33": "o",
  "bgm34": "ov",
  "bgm35": "ov",
  "bgm38": "o",
  "bgm39": "ov",
  "bgm40": "o",
  "bgm42": "ov",
  "bgm43": "ov",
  "bgm43trial": "o",
  "bgm44": "ov",
  "bgm45": "ov",
  "bgm46": "ov",
  "bgm48": "ov",
  "bgm49": "o",
  "bgm50": "ov",
  "bgm51": "o",
  "bgm52": "opv",
  "bgm53": "opv",
  "bgm54": "opv",
  "bgm55": "opv",
  "bgm56": "opv",
  "bgm57a": "opv",
  "bgm57b": "opv",
  "bgm58": "opv",
  "bgm59": "opv",
  "bgm60": "opv",
  "bgm61": "opv",
  "bgm62": "opv",
  "bgm63": "p",
  "bgm63a": "opv",
  "bgm63b": "opv",
  "bgm64": "opv",
  "bgm65": "opv",
  "bgm66": "opv",
  "bgm67": "opv",
  "bgm68": "copv",
  "bgm70": "op",
  "bgm71": "opv",
  "bgm72": "opv",
  "bgm73": "opv",
  "bgm74": "opv",
  "bgm75": "opv",
  "bgm76": "opv",
  "demo01": "p",
  "demo02": "p",
  "demo03": "p",
  "demo04": "p",
  "fate": "o",
  "heaven": "o",
  "mute": "o",
  "unlimited": "o",
  "ステータス": "p",
}
